import { createSymbols } from 'utils/helpers';

const Types = createSymbols([
    'RESET',
    'RESET_ALL',
    'ADD_BEFORE_COLUMN',
    'CHANGE_COLUMN_POSITION',
    'SET_SEARCH_QUERY',
    'SET_FILTER',
    'RESET_FILTER',
    'APPLY_FILTER',
    'SET_KEYWORD',
    'SET_TOTAL_KEYWORDS',
    'SET_ERROR',
    'SET_LOADING',
    'SET_STRICT_SEARCH',
    'FETCH',
    'SELECT',
    'SET_DATA',
    'SET_SORT',
    'UPDATE_DATA',
    'UPDATE_PAGINATION',
    'FETCH_HISTORY',
    'SEE_REPORT',
    'SET_HISTORY',
    'DEEP_SEARCH',
    'CLEAR_SELECTED',
    'TRACK_KEYWORDS',
    'ADD_TRACKED',
    'FETCH_PRODUCT',
    'SET_PRODUCT',
    'SET_END',
    'ADD_COLUMNS',
    'SET_COLUMNS',
    'REMOVE_COLUMN',
    'SET_STRICT_SEARCH',
    'SET_NO_RESULTS',
    'FETCH_CATEGORIES',
    'FETCH_CATEGORIES_FAIL',
    'SET_CATEGORIES',
    'UPDATE_CATEGORIES',
    'PIN_CATEGORY',
    'REMOVE_CATEGORY',
]);

export default Types;
